import { defineModel, resolvesTo } from 'customer-flows/utils/quote/models'

export default defineModel({
  channelId: resolvesTo('channelId')
})
